import React from 'react';
import { GENERAL } from '../../../assets/images/images';

function CardCorner (props) {
  const { data: {bars, feedback, isAppointment, is_history, is_scheduler_solo}, styleClass, onReviewClick} = props;

  if ((bars < 5 || !feedback || typeof feedback.classification === 'undefined') && (!isAppointment && !is_history && !is_scheduler_solo)) {
    return (<React.Fragment />);
  }
    if (isAppointment && !feedback?.classification) {
    return (<React.Fragment />);
  }
  const classification = feedback?.classification ?? '';
  const observation = feedback?.observation ?? '';
  const reviewIcon = () => {
    if (observation) {
      return <img src={GENERAL.starBallon} alt="review" />
    }
    return <img src={GENERAL.starFill} alt="review" />;
  }

  const handleReviewClick = (event) => {
    if (event) {
      event.stopPropagation();
    }
    if (onReviewClick) {
      onReviewClick();
    }
  }

  return (
    <div className={`card-corner-container ${styleClass ? styleClass : ''}`}
      style={{ backgroundImage: `url(${GENERAL.cardCorner})` }}>
      <div className="review-container d-inline-flex justify-content-end"
        role={onReviewClick ? 'button' : undefined}
        tabIndex={onReviewClick ? 0 : undefined}
        onClick={onReviewClick ? handleReviewClick : undefined}
        onKeyDown={onReviewClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleReviewClick(e); } } : undefined}>
        <div className="review-value"> {classification} </div>
        { reviewIcon() }
      </div>
    </div>
  );
}

export default CardCorner;